<template>
  <div id="site-footer">
    <div class="adaptive-column-content">
      <div class="top-line">
        <div class="logo-descriptor">
          <img :src="require('@/assets/images/logo-white.svg')" />
          <div class="descriptor">Восточная<br/>домашняя кухня</div>
        </div>
        <div class="main-links">
          <router-link :to="{ name: 'Index' }">Меню</router-link>
          <router-link :to="{ name: 'Conditions' }">Доставка и оплата</router-link>
          <router-link :to="{ name: 'Restaurants' }">Рестораны</router-link>
<!--          <router-link :to="{ name: 'About' }">О доставке</router-link>-->
        </div>
        <div class="block-with-title">
          <div class="title">Адреса</div>
          <div class="text">
            Санкт-Петербург:<br/>
            Ул Оптиков 51/1,<br/>
            Ул Достоевского 6,<br/>
            Наб Реки Фонтанки 92
          </div>
        </div>
        <div class="block-with-title">
          <div class="title">Звоните</div>
          <div class="text">
            <phone />
          </div>
        </div>
        <div class="block-with-title last">
          <div class="title">Часы работы</div>
          <div class="text">с 10:00 до 2:00</div>
        </div>
        <router-link class="returner" v-mg-smooth-scroll="{ autoDetectOffsetByTopBar: true }" :to="{ hash: '#main-layout-flex' }">
          <svg-inline :src="require('@/assets/icons/arrow-up.svg')" />
        </router-link>
      </div>
      <div class="separator-line"></div>
      <div class="middle-line" v-if="isSmartphone">
        <div class="block-with-title">
          <div class="title">Звоните</div>
          <div class="text">
            <phone />
          </div>
        </div>
        <div class="block-with-title last">
          <div class="title">Часы работы</div>
          <div class="text">с 10:00 до 2:00</div>
        </div>
      </div>
      <div class="bottom-line">
<!--        <div class="documents">-->
<!--          <a>Публичная оферта</a>-->
<!--          <a>Соглашение об обработке персональных данных</a>-->
<!--        </div>-->
        <div class="copyright">
          Copyright ©Mangal Grill
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Phone from '/src/components/Phone'

  export default {
    name: 'SiteFooter',
    components: {
      Phone
    },
    computed: {
      // isMenuPage () {
      //   return ['Index', 'MenuCategory'].includes(this.$route.name)
      // }
    }
  }
</script>



// WEBPACK FOOTER //
// src/blocks/SiteFooter.vue